module.exports = __webpack_public_path__ + "img/roots-pass-2023-mobile.jpg";